const allowedFileType = [
  "image/jpeg", // JPEG images
  "image/png", // PNG images
  "image/gif", // GIF images
  "image/webp", // WEBP images
  "image/bmp", // BMP images
  "image/tiff", // TIFF images
  "image/svg+xml", // SVG images
];

export const SupportTicketStatic = {
  dialogHeader: "SUPPORT_TICKET.REPORT_AN_ISSUE",
  FORM_DATA: {
    fields: [
      {
        name: "title",
        label: "SUPPORT_TICKET.TITLE",
        type: "text",
        placeholder: "SUPPORT_TICKET.ENTER_TITLE",
        isRequired: true,
      },
      {
        name: "description",
        label: "SUPPORT_TICKET.DESCRIPTION",
        type: "textarea",
        placeholder: "SUPPORT_TICKET.ENTER_DESCRIPTION",
        isRequired: true,
      },
      {
        name: "steps_to_reproduce",
        label: "SUPPORT_TICKET.STEPS_TO_REPRODUCE",
        type: "textarea",
        placeholder: "SUPPORT_TICKET.ENTER_STEPS",
        isRequired: false,
      },
      {
        name: "impact_level",
        label: "SUPPORT_TICKET.IMPACT_LEVEL",
        type: "btn-select",
        placeholder: "",
        isRequired: true,
      },
      {
        name: "attachments",
        label: "SUPPORT_TICKET.ATTACHMENTS",
        type: "file-upload",
        placeholder: "",
        isRequired: false,
      },
    ],
  },
  fileUploadContent: {
    placeholderText: "SUPPORT_TICKET.DRAG_DROP_YOUR_FILES_UPLOAD",
  },
};
